import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import MessageRecherche from './messageRecherche';
import MessageResultatRecherche from './messagerieResultatRecherche';
import MessageContenu from './messageContenu';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const Messagerie = (props) => {
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState('');
  const [socket, setSocket] = useState(null);
  const [search, setSearch] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [error, setError] = useState(false);
  const [destinataire, setDestinataire] = useState(null);
  const [mess_env, setMess_env] = useState([]);
  const [notification, setNotification] = useState([]);
  const [historique, setHistorique] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const nom = (userData) => {
    const userType = userData.user.type;
    const userDonnee = userData.user.donnée.results[0];
    let userName = "";
  
    if (userType === "joueur") {
      userName = userDonnee.nom_joueur;
    } else if (userType === "arbitre") {
      userName = userDonnee.nom;
    } else if (userType === "coach") {
      userName = userDonnee.nom_coach;
    }
  
    return userName;
  };
  const nom_ = nom(props.userData);
  const apiUrl = process.env.REACT_APP_API_URL;
  const socketUrl = process.env.REACT_APP_SOCKET_URL;

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/message/historique`,
          {
            id: props.userData.user.donnée.results[0].id,
            type: props.userData.user.type
          },
          {
            withCredentials: true
          }
        );
        
        setHistorique(response.data);
        setError(null);
        setIsLoading(false);
      } catch (error) {
        if (error.response) {
          setError(error.response.data.message);
        } else {
          setError(true);
        }
        setIsLoading(false);
      }
    };
    fetchData();
  }, [props.userData.user, mess_env, notification, apiUrl]);

  useEffect(() => {
    try {
      const newSocket = io(socketUrl,{
        withCredentials: true
      });

      newSocket.on('connect', () => {
        setSocket(newSocket);
      });
      
      newSocket.emit('userConnect', props.userData.user.donnée.results[0].id, props.userData.user.type);
      newSocket.on('recherche', (Messages) => {
        setMessages([Messages]);
      });

      newSocket.on('message', (receivedMessage) => {
        if (receivedMessage.id_expediteur === props.userData.user.donnée.results[0].id) {
          setMess_env((prevMessages) => [...prevMessages, receivedMessage]);
        } else if (!destinataire ) {
          setNotification((prevNotification) => [
            ...prevNotification,
            { id: Date.now(), nom_exp: receivedMessage.nom_exp, logo: receivedMessage.logo, date: receivedMessage.date, show: true },
          ]);
          setTimeout(() => {
            setNotification((prevNotifications) => prevNotifications.slice(1));
          }, 20000);
        }
         else if (!destinataire || receivedMessage.id_expediteur === destinataire.id) {
          setMess_env((prevMessages) => [...prevMessages, receivedMessage]);
        } else {
          setNotification((prevNotification) => [
            ...prevNotification,
            { id: Date.now(), nom_exp: receivedMessage.nom_exp, logo: receivedMessage.logo, date: receivedMessage.date, show: true },
          ]);
          setTimeout(() => {
            setNotification((prevNotifications) => prevNotifications.slice(1));
          }, 20000);
        }
      });

      newSocket.on('disconnect', () => {});

      return () => {
        newSocket.disconnect();
      };
    } catch (error) {
      setError(true);
    }
  }, [destinataire, props, socketUrl]);

  const sendMessage = () => {
    if (socket && messageInput.trim() !== '') {
      socket.emit('userConnect', props.userData.user.donnée.results[0].id, props.userData.user.type);
      socket.emit('message', messageInput, props.userData.user.donnée.results[0].id, props.userData.user.type, props.userData.user.donnée.results[0].prenom, nom_ ,destinataire);
      setMessageInput('');
    }
  };

  const handleSearch = async () => {
    try {
      setSearchResults([]);
      const response = await axios.post(
        `${apiUrl}/recherche/utilisateur`,
        { recherche: search },
        { withCredentials: true }
      );
      setSearchResults(response.data);
    } catch (error) {
      console.error('Erreur lors de la recherche des utilisateurs', error);
    }
  };

  const recherche = (nom, prenom, type, id, logo) => {
    if (socket) {
      setSearchResults([]);
      setMessages([]);
      setMess_env([]);
      setSearch("");
      setDestinataire({ nom, prenom, type, id, logo });
    }
  };

  useEffect(() => {
    if (socket && destinataire) {
      socket.emit('userConnect', props.userData.user.donnée.results[0].id, props.userData.user.type);
      socket.emit('recherche', destinataire.id, destinataire.nom, destinataire.prenom, destinataire.type, props.userData.user.donnée.results[0].id, props.userData.user.type, destinataire.logo);
    }
  }, [socket, destinataire, props]);

  return (
    <>
      <style>
        {`
          body {
            background: #2c3e50;
          }
        `}
      </style>
      {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br />
          <span className="loader"></span>
        </div>
      )}
      {error && (
        <>
          <Navigation />
          <div id="alert-message" className="alert4">
            <strong>ERROR ! </strong>Erreur Serveur <span id="alert-text"></span>
          </div>
        </>
      )}
      {notification.length > 0 && (
        <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 1050, position: 'fixed' }}>
          {notification.map((notification) => (
            <Toast
              key={notification.id}
              onClose={() => setNotification((prevNotifications) => 
                prevNotifications.filter((n) => n.id !== notification.id)
              )}
              show={notification.show}
              delay={20000}
              autohide
            >
              <Toast.Header>
                <img
                  style={{width: '25px', borderRadius : '50%'}}
                  src='/img/notification.png'
                  className="rounded me-2"
                  alt=""
                />
                <strong className="me-auto">{notification.nom_exp}</strong>
              </Toast.Header>
                <Toast.Body>
                  {notification.date}:  Nouveau message
                </Toast.Body>
            </Toast>
          ))}
        </ToastContainer>
      )}
      <div id="frame">
        <div id="sidepanel">
          <MessageRecherche handleSearch={handleSearch} search={search} setSearch={setSearch} />
          <MessageResultatRecherche searchResults={searchResults} recherche={recherche} setMessages={setMessages} userData={props.userData} historique={historique} messages={messages} />
        </div>
        {messages.length > 0 ? (
          <MessageContenu messages={messages} mess_env={mess_env} userData={props.userData} sendMessage={sendMessage} setMessageInput={setMessageInput} messageInput={messageInput} />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Messagerie;
